import React from 'react';

const NAV = [
  { id: 'show',    label: 'SHOW' },
  { id: 'crew',    label: 'CREW' },
  { id: 'feeds',   label: 'FEEDS' },
  { id: 'panel',   label: 'PANEL' },
  { id: 'intel',   label: 'INTEL' },
  { id: 'archive', label: 'ARCHIVE' },
  { id: 'admin',   label: 'ADMIN' },
];

const STATUS_CLS = {
  LIVE: '', PREP: 'prep', REHEARSAL: 'rehearsal', HOLD: 'hold',
  DEGRADED: 'prep', PARTIAL_COVERAGE: 'prep', OFFLINE: 'hold',
};

export default function ShowHeader({ mode, onNavigate, status, episode, sensorSummary, nextSpeaker }) {
  const pillCls = STATUS_CLS[status] ?? 'prep';
  const topic = episode?.lead_topic || episode?.leadTopic || episode?.title || 'No active topic';
  const seg = episode?.active_segment || episode?.activeSegment || '—';
  const nextSeg = episode?.next_segment || episode?.nextSegment || '—';
  const ready = sensorSummary ? `${sensorSummary.live}/${sensorSummary.total} sensors live` : '—';

  return (
    <div className="studio-topbar" data-testid="studio-topbar">
      <div className="brand" data-testid="studio-brand">SIGNAL STUDIO</div>
      <div className={`live-pill ${pillCls}`} data-testid="studio-status">{status || 'PREP'}</div>

      <div className="studio-topbar-stat" data-testid="studio-topic">
        <span className="k">Topic</span>
        <span className="v">{String(topic).slice(0, 48)}</span>
      </div>
      <div className="studio-topbar-stat" data-testid="studio-segment">
        <span className="k">Segment</span>
        <span className="v">{seg}</span>
      </div>
      <div className="studio-topbar-stat" data-testid="studio-next-speaker">
        <span className="k">Next</span>
        <span className="v">{String(nextSpeaker || '—').toUpperCase()}</span>
      </div>
      <div className="studio-topbar-stat" data-testid="studio-sensors">
        <span className="k">Sensors</span>
        <span className="v">{ready}</span>
      </div>

      <div className="studio-topbar-spacer" />

      <div className="studio-nav" data-testid="studio-nav">
        {NAV.map((n) => (
          <button
            key={n.id}
            className={mode === n.id ? 'is-active' : ''}
            onClick={() => onNavigate && onNavigate(n.id)}
            data-testid={`studio-nav-${n.id}`}
          >
            {n.label}
          </button>
        ))}
      </div>
    </div>
  );
}
